var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',{staticClass:"content__title",attrs:{"id":"page-title"}},[_vm._v("Not Found")])}
var staticRenderFns = []

export { render, staticRenderFns }